var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { replaceUrlSearchParams } from "@common/replace-url-search-params";
import { joinUrlSearchParams } from "@common/join-url-search-params";
var IGNORE_SEARCH_PARAMS = ["pageSize", "pageNumber", "siteId"];
var hasParamsValue = function (params, ignoreParams) {
    var e_1, _a;
    var newSearchParams = new URLSearchParams(params);
    if (ignoreParams)
        ignoreParams.forEach(function (param) { return newSearchParams.delete(param); });
    try {
        for (var _b = __values(newSearchParams.values()), _c = _b.next(); !_c.done; _c = _b.next()) {
            var value = _c.value;
            if (value)
                return true;
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return false;
};
export var urlSearchParamsMiddleware = function (useSWRNext) {
    return function (key, fetcher, config) {
        var _a;
        var browserUrlSearchParams = new URLSearchParams(window.location.search);
        var keyParams = "";
        if (typeof key === "function") {
            var params = key();
            keyParams = Array.isArray(params)
                ? params[0].split("?")[1]
                : (_a = params === null || params === void 0 ? void 0 : params.split("?")[1]) !== null && _a !== void 0 ? _a : "";
        }
        var swr = useSWRNext(key, fetcher, config);
        if (!keyParams)
            return swr;
        var SWRSearchParams = new URLSearchParams(keyParams);
        /* Check if we have pagination */
        var infiniteSWR = swr;
        if (infiniteSWR === null || infiniteSWR === void 0 ? void 0 : infiniteSWR.size) {
            SWRSearchParams.set("pageNumber", "" + infiniteSWR.size);
        }
        /* Make sure we are not overwriting other search params */
        var joinedUrlSearchParams = joinUrlSearchParams(SWRSearchParams, browserUrlSearchParams);
        /* If no param exists and we are on page one clear search params */
        if (!hasParamsValue(joinedUrlSearchParams, IGNORE_SEARCH_PARAMS) &&
            (infiniteSWR === null || infiniteSWR === void 0 ? void 0 : infiniteSWR.size) === 1) {
            replaceUrlSearchParams("");
            return swr;
        }
        replaceUrlSearchParams(joinedUrlSearchParams);
        return swr;
    };
};
